module.exports = __webpack_public_path__ + "img/department.a5171836.svg";